import React from "react"

import { MultipleImages, TextImage, ImageTextBlend } from "../../../components/PageHero"

import "./index.css"

const PageTemplate = ({ data }) => {
    let contentData = data.contentfulPage || {}
    let pageHero = contentData.pageHero || {}
    let pageHeroTitle = contentData.headerPageTitle ? contentData.headerPageTitle : contentData.pageTitle

    let PageHeroLayout = pageHero?.multipleImages 
        ? <MultipleImages heroContent={pageHero.multipleImages} pageHeroTitle={pageHeroTitle} />
        : pageHero?.textImage 
            ? <TextImage heroContent={pageHero.textImage} pageHeroTitle={pageHeroTitle} isAlignCenter={pageHeroTitle === 'Marc Marquez'} />
            : pageHero?.imageTextBlend 
                ? <ImageTextBlend heroContent={pageHero.imageTextBlend} pageHeroTitle={pageHeroTitle} />
                : ''

    return (
        <div className="page">
            {PageHeroLayout}
        </div>
    )
}

export default PageTemplate
